import instanciaAxios from './InterceptorAxios';
const servicioRecuperaNru = {
    recuperanru(url,datos){
      let request = {
        method: 'post',
        url: url,
        data: datos,
        responseType: 'arraybuffer'
    }
        return instanciaAxios(request);
    }
}

export default servicioRecuperaNru;